function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 128,
  cy: 128,
  r: 128,
  fill: "#2b2f30"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M162.2979,188.3135H84.356a4.5007,4.5007,0,0,1-3.9966-2.4317L68.3286,162.6309H51.5068a4.5,4.5,0,0,1-4.5-4.5v-27.752H32.0483v27.4424a4.5,4.5,0,0,1-9,0V97.625a4.5,4.5,0,1,1,9,0v23.7544H47.0068V99.75a4.5,4.5,0,0,1,4.5-4.5h17.167L80.625,77.5244A4.5,4.5,0,0,1,84.356,75.54h21.48V54.1953H88.4854a4.5,4.5,0,0,1,0-9h64.0253a4.5,4.5,0,0,1,0,9H136.0391V75.54H155.43a4.5015,4.5015,0,0,1,3.1943,1.33L176.8633,95.25H187.19a4.5,4.5,0,0,1,4.5,4.5V110.19h13.0088V94.4385a4.5,4.5,0,0,1,4.5-4.5h21.502a4.5,4.5,0,0,1,4.5,4.5v71.6406a4.5,4.5,0,0,1-4.5,4.5h-21.502a4.5,4.5,0,0,1-4.5-4.5V154.1113H189.4805l-23.544,32.3506A4.5009,4.5009,0,0,1,162.2979,188.3135Zm-75.2037-9h72.9136l23.544-32.3506a4.5021,4.5021,0,0,1,3.6386-1.8516h22.0088a4.5,4.5,0,0,1,4.5,4.5v11.9678h12.502V98.9385h-12.502V114.69a4.5,4.5,0,0,1-4.5,4.5H187.19a4.5,4.5,0,0,1-4.5-4.5V104.25h-7.7011a4.5016,4.5016,0,0,1-3.1944-1.33L153.5557,84.54H131.5391a4.5,4.5,0,0,1-4.5-4.5V54.1953H114.8364V80.04a4.5,4.5,0,0,1-4.5,4.5H86.749L74.7979,102.2651a4.5,4.5,0,0,1-3.731,1.9844h-15.06v49.3814h15.06a4.5008,4.5008,0,0,1,3.9966,2.4316Z",
  fill: "#ffc02c"
});

var SvgWebappIconEngineAlertDarkTheme = function SvgWebappIconEngineAlertDarkTheme(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWebappIconEngineAlertDarkTheme, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/webapp-icon-engine-alert-dark-theme.9daa2aed.svg";
export { ForwardRef as ReactComponent };